import React from 'react'
import { CircularProgressbar ,buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

export default function Tables() {
  const percentage = 66;
  return (
    <div id='TestCircle' style={{ width: 200, height: 210 }} className='TablesContainer'>
     
    </div>
  )
}
